import { PropsWithChildren } from "react"
import { makeStyles } from "tss-react/mui"
import { Box, Stack, Typography } from "@mui/material"
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { useLocationState } from "../../../core/router/routerHooks"
import { ImportResultData } from "../../../core/api/apiTypes"
import { PageHeader } from "../pageHeader/PageHeader"
import { Page } from "../pageHeader/PageHeaderApi"

const useStyles = makeStyles()((theme) => ({
    container: {
        background: theme.palette.common.white,
        textAlign: "center",
        color: theme.palette.text.primary,
        padding: "2rem",
        borderRadius: "0.75rem",
    },
    iconCheck: {
        color: theme.palette.tailwind.green[500],
        fontSize: "11rem",
    },
    spacing: {
        paddingTop: "1rem",
    },
}))

type ImportResultProps = Readonly<PropsWithChildren<{}>>

export function ImportResult({ children }: ImportResultProps) {
    const { classes } = useStyles()

    const { importResult } = useLocationState<ImportResultData>({
        importResult: {
            rowChanges: {
                inserted: 0,
                updated: 0,
                deleted: 0,
            },
        },
    })

    return (
        <>
            <LocalizedStrict id="import-result-title" attrs={{ title: true }}>
                <PageHeader page={Page.IMPORT_RESULT} title="Import result">
                    {children}
                </PageHeader>
            </LocalizedStrict>
            <Stack direction="column" spacing="1.5rem" className={classes.container}>
                <FontAwesomeIcon icon={faCheckCircle} className={classes.iconCheck} />
                <LocalizedStrict id="import-result-succeeded">
                    <Typography variant="h5">Import succeeded</Typography>
                </LocalizedStrict>
                <LocalizedStrict id="import-result-results">
                    <Typography variant="body1" className={classes.spacing}>
                        Results
                    </Typography>
                </LocalizedStrict>

                <Stack direction="row" spacing="2rem" justifyContent="center">
                    <Box textAlign="left">
                        <LocalizedStrict id="import-result-created">
                            <Typography variant="body1">Created</Typography>
                        </LocalizedStrict>
                        <LocalizedStrict id="import-result-updated">
                            <Typography variant="body1">Updated</Typography>
                        </LocalizedStrict>
                        <LocalizedStrict id="import-result-deleted">
                            <Typography variant="body1">Deleted</Typography>
                        </LocalizedStrict>
                    </Box>
                    <Box textAlign="right">
                        <Typography variant="body1">{importResult.rowChanges.inserted}</Typography>
                        <Typography variant="body1">{importResult.rowChanges.updated}</Typography>
                        <Typography variant="body1">{importResult.rowChanges.deleted}</Typography>
                    </Box>
                </Stack>
            </Stack>
        </>
    )
}
